<template>
	<header id="header" class="bg-dark-brand py-8" v-outside-click="close">
		<div class="container relative">
			<div class="flex justify-between items-center">
				<div class="dealer__title">
					<router-link to="/" class="dealer__logo" @click.native.prevent="open = false">
						<img :src="location?.dealer?.logo?.thumb600" alt="dealer logo" v-if="$store.state.screenWidth <= 983">
						<img src="/images/front/svg/nsi.svg" alt="nsi" v-else>
						<span v-if="$store.state.screenWidth > 983">{{ location?.dealer?.name }}</span>
					</router-link>
				</div>
				<nav class="header__nav" role="navigation">
					<ul class="flex space-x-9">
						<li>
							<router-link to="/" class="text-white font-bold uppercase">Inventory</router-link>
						</li>
						<li>
							<a class="text-white uppercase font-bold" href="https://build.nauticstarboats.com/" target="_blank">Design Your Boat</a>
						</li>
					</ul>
				</nav>
				<button id="mobile__menu--button" class="mobile__trigger mobile-menu-button--collapse" tabindex="0" type="button" @click.prevent="open = !open">
					Mobile Menu Button
					<span class="mobile-menu-button-box">
						<span class="mobile-menu-button-inner"></span>
					</span>
				</button>
			</div>
		</div>
		<transition name="fade">
			<nav id="mobile__nav" role="navigation" v-if="open && $store.state.screenWidth <= 983">
				<div class="container">
					<div class="inner__menu">
						<ul>
							<li>
								<router-link to="/" @click.native.prevent="open = false">Inventory</router-link>
							</li>
							<li>
								<a href="https://build.nauticstarboats.com/" target="_blank" @click="open = false">Design Your Boat</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</transition>
	</header>
</template>

<script>
	export default {
		data() {
			return {
				open: false
			};
		},
		computed: {
			location() {
				return this.$store.state.location;
			}
		},
		methods: {
			close() {
				this.open = false;
			}
		}
	}
</script>